import clsx from 'clsx'
import React from 'react'
import { AlertCircle, CheckCircle2, AlertTriangle, Info } from 'lucide-react'

export const Message: React.FC<{
  className?: string
  error?: React.ReactNode
  message?: React.ReactNode
  success?: React.ReactNode
  warning?: React.ReactNode
}> = ({ className, error, message, success, warning }) => {
  const messageToRender = message || error || success || warning

  if (messageToRender) {
    const Icon = error
      ? AlertCircle
      : success
        ? CheckCircle2
        : warning
          ? AlertTriangle
          : Info

    return (
      <div
        className={clsx(
          'flex items-start gap-3 rounded-xl border p-4',
          {
            'border-green-500/30 bg-green-500/10 text-green-700 dark:text-green-400': Boolean(success),
            'border-yellow-500/30 bg-yellow-500/10 text-yellow-700 dark:text-yellow-400': Boolean(warning),
            'border-destructive/30 bg-destructive/10 text-destructive': Boolean(error),
            'border-blue-500/30 bg-blue-500/10 text-blue-700 dark:text-blue-400': !error && !success && !warning && message,
          },
          className,
        )}
      >
        <Icon className="h-5 w-5 shrink-0 mt-0.5" />
        <div className="text-sm font-medium">{messageToRender}</div>
      </div>
    )
  }
  return null
}
